import { createContext, Component } from 'react';
import PropTypes from 'prop-types';
import CloneModal from 'SalesContentIndexUI/components/clone/CloneModal';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import FolderNavModal from 'SalesContentIndexUI/components/folderNav/FolderNavModal';
import FolderModal from 'SalesContentIndexUI/components/folder/FolderModal';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../u... Remove this comment to see the full error message
import { assertPropsDefined } from '../utils/PropValidationUtils';

// MoveModal not migrated yet
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SalesContentAppContext = /*#__PURE__*/createContext({
  openCloneModal: () => {},
  closeCloneModal: () => {},
  openMoveModal: () => {},
  closeMoveModal: () => {},
  openRenameFolderModal: () => {},
  closeRenameFolderModal: () => {}
});
class SalesContentAppContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cloneModalProps: null,
      moveModalProps: null,
      renameFolderModalProps: null
    };
  }
  getContext() {
    return {
      closeCloneModal: () => this.setState({
        cloneModalProps: null
      }),
      openCloneModal: cloneModalProps => this.setState({
        cloneModalProps
      }),
      closeMoveModal: () => this.setState({
        moveModalProps: null
      }),
      openMoveModal: moveModalProps => this.setState({
        moveModalProps
      }),
      closeRenameFolderModal: () => this.setState({
        renameFolderModalProps: null
      }),
      openRenameFolderModal: renameFolderModalProps => this.setState({
        renameFolderModalProps
      })
    };
  }
  renderCloneModal() {
    if (this.state.cloneModalProps) {
      return /*#__PURE__*/_jsx(CloneModal, Object.assign({}, this.state.cloneModalProps));
    }
    return null;
  }
  renderMoveModal() {
    if (this.state.moveModalProps) {
      return /*#__PURE__*/_jsx(FolderNavModal, Object.assign({}, this.state.moveModalProps));
    }
    return null;
  }
  renderRenameFolderModal() {
    if (this.state.renameFolderModalProps) {
      return /*#__PURE__*/_jsx(FolderModal, Object.assign({}, this.state.renameFolderModalProps));
    }
    return null;
  }
  render() {
    assertPropsDefined({
      children: this.props.children
    });
    return /*#__PURE__*/_jsxs(SalesContentAppContext.Provider, {
      value: this.getContext(),
      children: [this.props.children, this.renderCloneModal(), this.renderMoveModal(), this.renderRenameFolderModal()]
    });
  }
}
SalesContentAppContainer.propTypes = {
  children: PropTypes.node.isRequired
};
export default SalesContentAppContainer;